import { Theme, makeStyles, createStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tableHeadCell: {
      borderBottom: "1px rgba(162, 161, 168, 0.10) !important",
      background: "#7152F3 !important",
      color: "#FFF !important",
       fontSize: "12px !important",
       lineHeight: "16px !important",
    },
    tableBodyCell: {
      padding: "0 5px !important",
      fontSize: "12px !important",
    },
  })
);

export { useStyles };
